import React from 'react';
import {
	View,
	StyleSheet,
	useWindowDimensions,
	TouchableHighlight,
	Platform,
} from 'react-native';
import HeaderContainer from '../../components/shared/Header/Header.container';
import ReportsCalendarContainer from '../../components/shared/ReportsCalendar/ReportsCalendar.container';
import colors from '../../config/colors';
import WebHeader from '../../components/shared/Header/WebHeader.component';
import getShadowStyle from '../../config/shadow';
import DayReportsContainer from "./DayReports/DayReports.container"
import ImageIcon from '../../components/shared/Icon/ImageIcon.component';
import AttendanceStatsCard from '../HomePage/SubComponents/AttendanceStatsCard';
import Typography from '../../components/shared/Typography/Typography.component';
import { i18nService } from '../../services/i18n.service';
import { MonthAttendanceResponse } from '../../services/hooks/useMonthAttendance.hook';
interface Props {
	navigation: any;
	monthlyAttendanceData: MonthAttendanceResponse | null;
}
const CalendarAttendanceReportsWeb = ({
	navigation,
	monthlyAttendanceData,
}: Props) => {
	const windowHeight = useWindowDimensions().height;
	const contentBlock = {

		backgroundColor: colors.white,
		width: 354,
		height: windowHeight - 167,
		flexShrink: 0,
		padding: 24,
		borderRadius: 8,
		...Platform.select({
			web: { gap: 16, boxShadow: '2px 2px 16px 0 rgba(0, 0, 0, 0.04)' },
			ios: { shadowColor: '#000', shadowOffset: { width: 2, height: 2 }, shadowOpacity: 0.04, shadowRadius: 16 },
			android: { elevation: 2 },
		}),
	};

	const leftPanel = {
		flex: 1,
		flexDirection: 'column' as const,
		gap: 24,
		height: windowHeight - 167,
	};

	return (
		<>
			<HeaderContainer
				containerStyle={{ backgroundColor: colors.white }}
				navigation={navigation}
				component={WebHeader}
			/>
			<View style={styles.container}>
				<View style={leftPanel}>
					<AttendanceStatsCard
						showButton={false}
						monthlyAttendanceData={monthlyAttendanceData}
					/>
					<DayReportsContainer navigation={navigation} splitCards={true} />
				</View>
				<View style={contentBlock} nativeID='contanetBlockWeb2'>
					<View style={styles.clockHeader}>
						<ImageIcon name="clockInLogo" width={108} height={30} />
						<Typography color="primaryDarkBlue" font="medium" size={14}>
							{i18nService.translate('attendanceReports')}
						</Typography>
					</View>
					<ReportsCalendarContainer />
				</View>
			</View>
		</>
	);
};

const styles = StyleSheet.create({
	line: {
		opacity: 0.2,
		width: '95%',
		height: 0,
		borderTopColor: '#525962',
		borderTopWidth: 2,
		marginVertical: 5,
	},
	clockHeader: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 16,
	},
	recordLine: {
		opacity: 0.2,
		width: '100%',
		height: 0,
		borderTopColor: '#525962',
		borderTopWidth: 2,
		marginVertical: 5,
	},
	container: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-evenly',
		paddingHorizontal: 160,
		gap: 24,
		paddingVertical: 28
		
	},
	detailsHeader: {
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 20,

	},
	addButtonHolder: {
		flexDirection: 'row',
		width: '100%',
		padding: 10,
		flex: 2,
	},
	tableHolder: {
		width: '100%',
		minHeight: 140,
		maxHeight: 190,
		direction: 'ltr',
		paddingHorizontal: 15,
		flex: 2,
	},
	fabButton: {
		borderRadius: 30,
		width: 40,
		height: 40,
		marginTop: 10,
		marginLeft: 10,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
	},
});

export default CalendarAttendanceReportsWeb;
